import { isFullTestIdInTestList } from "./testTrackingHelpers";
import { DecodedTestInformation } from "./variationId";

export function parseActiveFeatBitTests(
  testsCurrentlySavedInCookie: DecodedTestInformation[],
  activeDecodedTests: DecodedTestInformation[],
  currentLimit: number,
) {
  const abFeatureVariationArray: DecodedTestInformation[] = [];
  const newTests: DecodedTestInformation[] = [];
  let newLimit = currentLimit;

  activeDecodedTests.forEach((activeTest) => {
    // Existing or Fallthrough tests should still be checked and kept in variation Id if they are active (not off/deleted) and in the cookie
    if (
      isFullTestIdInTestList(testsCurrentlySavedInCookie, activeTest.fullTestId)
    ) {
      abFeatureVariationArray.push(activeTest);
    }
    // RuleMatch applies specifically applies on target page and we enroll if they do not previously have this test
    else if (
      activeTest.kind === "RuleMatch" &&
      !activeTest.exclusive &&
      newLimit > 0
    ) {
      abFeatureVariationArray.push(activeTest);
      newTests.push(activeTest);
      newLimit--;
    }
  });
  return { allEnrolledTests: abFeatureVariationArray, newTests, newLimit };
}

export function updateStorageForNewTests(newTests: DecodedTestInformation[]) {
  if (!newTests.length) return;
  newTests.forEach((test) => {
    sessionStorage.setItem(test.name, test.variant);
  });
}
